export const supplier = {
  "supplier.missing_id": "Fournisseur ID manquant",
  "supplier.no_id_provided": "Aucun ID de fournisseur n'a été fourni.",
  "supplier.back_to_search": "Retour à la recherche",
  "supplier.not_found": "Fournisseur introuvable",
  "supplier.not_exist": "Le fournisseur que vous recherchez n'existe pas.",
  "supplier.loading": "Chargement des détails...",
  "supplier.contact_success": "Votre message a été envoyé avec succès ! Le fournisseur vous contactera bientôt.",
  "supplier.contact_error": "Une erreur s'est produite lors de l'envoi. Veuillez réessayer.",
  "supplier.verified": "Vérifié",
  "supplier.reviews_count": "avis",
  "supplier.address": "Adresse complète",
  "supplier.phone": "Téléphone",
  "supplier.email": "Email",
  "supplier.website": "Site web",
  "supplier.contact": "Contacter",
  "supplier.call": "Appeler",
  "supplier.schedule": "Prendre RDV",
  "supplier.visit_website": "Visiter le site",
  "supplier.share": "Partager",
  "supplier.favorite": "Favoris",
  "supplier.review_success": "Votre avis a été soumis avec succès !",
  "supplier.review_error": "Une erreur s'est produite lors de la soumission de votre avis. Veuillez réessayer.",
  "supplier.login_to_review": "Connectez-vous pour laisser un avis",
  "supplier.no_photos": "Aucune photo disponible",
  "supplier.leave_review_for": "Laisser un avis pour",
  "supplier.rating": "Note",
  "supplier.star": "étoile",
  "supplier.stars": "étoiles",
  "supplier.comment": "Commentaire",
  "supplier.placeholder_comment": "Écrivez votre commentaire ici...",
  "supplier.no_products": "Aucun produit disponible",
  "supplier.characters": "caractères",
  "supplier.submitting": "Envoi...",
  "supplier.submit_review": "Soumettre l'avis",
  "supplier.overview": "Aperçu",
  "supplier.reviews": "Avis",
  "supplier.location": "Localisation",
  "supplier.gallery": "Galerie",
  "supplier.products": "Produits",
  "supplier.about": "À propos",
  "supplier.important_info": "Informations importantes",
  "supplier.verified_by_suji": "Entreprise vérifiée par Suji",
  "supplier.quick_response": "Réponse rapide aux demandes",
  "supplier.quality_service": "Service client de qualité",
  "supplier.avg_rating": "Note moyenne",
  "supplier.customer_reviews": "Avis clients",
  "supplier.status": "Statut",
  "supplier.leave_review": "Laisser un avis",
  "supplier.no_reviews": "Aucun avis pour le moment",
  "supplier.first_review": "Soyez le premier à laisser un avis sur cette entreprise",
  "supplier.first_review_button": "Laisser le premier avis",
  "supplier.location_access": "Localisation et accès",
  "supplier.get_directions": "Obtenir l'itinéraire",
  "supplier.practical_info": "Informations pratiques",
  "supplier.hours": "Horaires : Lun-Ven 8h-18h",
  "supplier.parking": "Parking disponible",
  "supplier.accessibility": "Accès handicapés",
  "supplier.contact_info": "Informations de contact",
  "supplier.call_now": "Appeler maintenant",
  "supplier.send_message": "Envoyer un message",
  "supplier.itinerary": "Obtenir l'itinéraire",
  "supplier.open_website": "Ouvrir le site web",
  "supplier.photos": "Photos",
  "supplier.similar_businesses": "Entreprises similaires",
  "supplier.see_details": "Voir détails",
  "supplier.contact_form_title": "Contacter",
  "supplier.your_name": "Votre nom",
  "supplier.placeholder_name": "Votre nom complet",
  "supplier.placeholder_email": "votre@email.com",
  "supplier.phone_number": "Téléphone",
  "supplier.placeholder_phone": "+234 xxx xxx xxxx",
  "supplier.subject": "Sujet",
  "supplier.select_subject": "Sélectionnez un sujet",
  "supplier.quote_request": "Demande de devis",
  "supplier.product_info": "Information produit",
  "supplier.partnership": "Partenariat",
  "supplier.support": "Support",
  "supplier.other": "Autre",
  "supplier.message": "Message",
  "supplier.placeholder_message": "Décrivez votre demande en détail...",
  "supplier.max_characters": "Maximum 500 caractères",
  "supplier.cancel": "Annuler",
  "supplier.send": "Envoyer",
  "supplier.sending": "Envoi...",
  "supplier.feature_not_available": "Cette fonctionnalité n'est pas encore disponible",
  "supplier.internal_message": "Message",
  "supplier.message_sent_success": "Votre message a été envoyé avec succès ! Le fournisseur vous contactera bientôt.",
  "supplier.message_sent_error": "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer.",
  "supplier.no_email": "Le fournisseur n'a pas d'email",
  "supplier.no_phone": "Le fournisseur n'a pas de numéro de téléphone",
  "supplier.location_not_available": "Localisation non disponible",
  "supplier.claim_business": "Vous possédez cette entreprise ?"
  ,
  "supplier.view_similar_products": "Voir tous les produits similaires",
  "supplier.price_on_request": "Prix sur demande"
};

export default supplier;
